import * as yup from 'yup';

export const specieSchema = yup.object({
    name: yup.string().label('name').required('Este campo es requerido'),
});

export type specieSchemaType = yup.InferType<typeof specieSchema>
